import { React, forwardRef, useState, useRef, useImperativeHandle, useEffect } from 'react';
import styled from 'styled-components';

import SelectOnPath from '../../image/SelectOn.png';
import SelectOffPath from '../../image/SelectOff.png';
import FetchModule from '../../Model/Share/Network/FetchModule.js';

const CountryCodeSelectBox = forwardRef((props, ref) => {
	const [isClicked, setIsClicked] = useState(false);
	const [defaultVal, setDefaultVal] = useState({ countryCode: '+82', countryNameKR: '대한민국', countryNameEN: 'South Korea', isAvailable: true });
	const [options, setOptions] = useState([{ countryCode: '+82', countryNameKR: '대한민국', countryNameEN: 'South Korea', isAvailable: true }]);

	const SelectRef = useRef();

	const { isOver } = props;

	useEffect(() => {
		const fetchModule = new FetchModule();
		(async () => {
			const responseData = await fetchModule.getDataOfCoachVersion2('sms_cert/country', 'GET');
			if (responseData.status === 200) {
				// isAvailable이 true인 국가만 필터링
				const availableCountries = responseData.data.filter(item => item.isAvailable);
				setOptions(availableCountries);
				// 대한민국을 기본값으로 설정 (있는 경우)
				const korea = availableCountries.find(item => item.countryCode === '+82');
				if (korea) {
					setDefaultVal(korea);
				} else if (availableCountries.length > 0) {
					setDefaultVal(availableCountries[0]);
				}
			}
		})();
	}, []);

	useEffect(() => {
		function handleOutsideClick(e) {
			if (!isClicked) return;

			// SelectBox 바깥 클릭이면 닫기
			if (SelectRef.current && !SelectRef.current.contains(e.target)) {
			SelectRef.current.style.border = '1px solid #CBCBCB';
			SelectRef.current.style.height = '34px';
			SelectRef.current.style.overflow = 'hidden';
			setIsClicked(false);
			}
		}

		document.addEventListener('mousedown', handleOutsideClick);
		return () => {
			document.removeEventListener('mousedown', handleOutsideClick);
		};
	}, [isClicked]);

	useImperativeHandle(ref, () => ({
		getValue: () => {
			return defaultVal.countryCode;
		},
		getCountry: () => {
			return defaultVal.countryNameKR;
		},
		getFullValue: () => {
			return defaultVal;
		}
	}));

	function onClick() {
		if (isClicked) {
			SelectRef.current.style.border = '1px solid #CBCBCB';
			SelectRef.current.style.height = `30px`;
			SelectRef.current.style.overflow = 'hidden';
			setIsClicked(false);
		}
		else {
			SelectRef.current.style.border = '1px solid #FF8B48';
			SelectRef.current.style.height = `240px`;
			SelectRef.current.style.overflowY = 'scroll';
			SelectRef.current.style.overflowX = 'none';
			setIsClicked(true);
		}
	}

	function optionalClick(index) {
		setDefaultVal(options[index]);
	}

	return (
		<TopLevelWrapper>
			<SelectBox
				ref={SelectRef}
				isClicked={isClicked}
				buttonPath={isClicked ? SelectOnPath : SelectOffPath}
				onClick={onClick}>
				{
					isClicked ?
						options.map((data, index) =>
							<OptionWrapper key={index} onClick={() => optionalClick(index)}>
								<Option isSelected={data.countryCode === defaultVal.countryCode && data.countryNameKR === defaultVal.countryNameKR}>
									<CountryName isSelected={data.countryCode === defaultVal.countryCode && data.countryNameKR === defaultVal.countryNameKR}>{data.countryNameKR}</CountryName>
									<CountryCodeText isSelected={data.countryCode === defaultVal.countryCode && data.countryNameKR === defaultVal.countryNameKR}>{data.countryCode}</CountryCodeText>
								</Option>
							</OptionWrapper>
						)
						:
						<OptionWrapper>
							<DefaultOption isOver={isOver}>
								<DefaultCountryName>{defaultVal.countryNameKR}</DefaultCountryName>
								<CountryCodeText>({defaultVal.countryCode})</CountryCodeText>
							</DefaultOption>
						</OptionWrapper>
				}
			</SelectBox>
		</TopLevelWrapper>
	)
});

export default CountryCodeSelectBox;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: column;

	width: 100%;
	height: 34px;

	margin-top: 10px;
`;

const SelectBox = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;

	justify-content: ${props => props.isClicked ? 'flex-start' : 'center'};
	align-items: flex-start;

	width: 100%;
	height: 34px;

	// border: 1px solid #CBCBCB;
	border: 1px solid #777777;
	border-radius: 8px;
	overflow: hidden;

	z-index: 2;

  	background: url(${props => props.buttonPath}) no-repeat 96% ${props => props.isClicked ? `3` : `55`}%;
	background-color: rgba(255, 255, 255, 1);
 	transition: all 0.3s ease-in-out;

	&:hover {
		cursor: pointer;
	}

	&::-webkit-scrollbar {
		width: 9px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px #FF8B48;
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const OptionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

	&:hover {
		cursor: pointer;
	}
`;

const Option = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;

	width: 100%;
	margin: 9px 0 9px 13px;
	gap: 8px;
`;

const DefaultOption = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;

	width: ${props => props.isOver ? 'calc(100% - 75px)' : 'calc(100% - 50px)'};
	height: 28px;
	margin: 0 0 0 10px;
	padding: 0 10px 0 0;
`;

const CountryCodeText = styled.span`
	font-family: NotoSansKR-Medium;
	font-size: 16px;
	color: ${props => props.isSelected ? '#FF8B48' : '#333333'};
	flex-shrink: 0;
`;

const CountryName = styled.span`
	font-family: NotoSansKR-Regular;
	font-size: 16px;
	color: ${props => props.isSelected ? '#FF8B48' : '#333333'};

	width: calc(100% - 130px);
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: keep-all;
`;

const DefaultCountryName = styled.span`
	font-family: NotoSansKR-Regular;
	font-size: 16px;
	color: #333333;

	flex: 1;
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

// const Flag = styled.span`
//   font-size: 18px;
//   line-height: 1;
//   width: 22px;
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   flex-shrink: 0;
// `;
